<template>
	<main class="common-main-container">
		<div
			style="
        position: fixed;
        top: 70px;
        z-index: 10001;
        backdrop-filter: blur(2px);
      "
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<header>
			<h1>My Projects</h1>

			<b-button
				class="new-addBtn"
				@click="$router.push({ name: 'createprojects' })"
			>
				<img class="mr-2" src="../../assets/common-icons/whiteAdd.svg" alt="" />
				Project
			</b-button>
		</header>
		<body class="my-2 w-100 d-flex">
			<b-container
				class="left-container"
				:style="
					allProjects && allProjects.totalProjects <= 0
						? 'width:100%'
						: 'width:70%'
				"
			>
				<section
					v-if="
						loadingProjects || (allProjects && allProjects.totalProjects > 0)
					"
					class="d-flex align-items-center justify-content-between w-100 px-3"
				>
					<h2>List of Projects</h2>
					<div ref="filters" class="position-relative">
						<b-button class="new-addBtn" @click="openFilter = !openFilter">
							<img
								class="mr-2"
								src="../../assets/common-icons/whitefilter.svg"
								alt=""
							/>
							<div
								class="mb-3"
								style="position: absolute; top: 1px; left: 31px"
								v-if="filterApllied"
							>
								<img src="../../assets/common-icons/fil_selected.svg" alt="" />
							</div>
							Filter
						</b-button>
						<div
							v-closable="{
								exclude: ['filters'],
								handler: 'hideFiltersDropdown',
							}"
							class="config-filter-dropdown"
							v-if="openFilter"
						>
							<section>
								<SingleSelect
									v-model="filters.projectStatus"
									:optionsArray="status"
									text="Project Status:"
								/>
							</section>
							<section class="mt-3">
								<SingleSelect
									v-model="filters.category"
									:optionsArray="categories"
									text="Category:"
								/>
							</section>
							<section class="mt-3">
								<SingleSelect
									v-model="filters.template"
									:optionsArray="sandboxTemplates"
									text="Template:"
									:hideEdit="true"
									nested
								/>
							</section>

							<div
								class="d-flex align-items-center justify-content-between filter-buttons mt-4"
							>
								<b-button @click="hideFiltersDropdown()">Cancel</b-button>
								<span>
									<b-button
										:disabled="disabeFilters"
										@click="resetFilters()"
										class="mr-3"
										>Reset</b-button
									>
									<b-button :disabled="disabeFilters" @click="applyFilters()"
										>Apply
									</b-button>
								</span>
							</div>
						</div>
					</div>
				</section>
				<hr
					class="mb-0"
					v-if="
						loadingProjects || (allProjects && allProjects.totalProjects > 0)
					"
				/>
				<section
					@scroll="onScroll"
					class="px-3 projects-overflow gap-15px my-3 w-100 h-100"
				>
					<section
						v-if="
							filterApllied &&
								!loadingProjects &&
								allProjectsList.length < 1 &&
								searchTopicTest == ''
						"
						class="h-100 d-flex align-items-center justify-content-center w-100"
					>
						<div class="text-center">
							<img src="../../assets/common-icons/empty-projects.svg" alt="" />
							<div class="no-data-txt">
								There are no projects available for the applied filter.
							</div>
						</div>
					</section>
					<section
						v-else-if="
							!filterApllied &&
								!loadingProjects &&
								allProjectsList.length < 1 &&
								searchTopicTest == ''
						"
						class="h-100 d-flex align-items-center justify-content-center w-100"
					>
						<div class="text-center">
							<img
								src="../../assets/projects-icons/empty-list-projects.svg"
								alt=""
							/>
						</div>
					</section>
					<section
						v-else-if="
							!loadingProjects && allProjects && allProjects.totalProjects <= 0
						"
						class="h-100 d-flex align-items-center justify-content-center w-100"
					>
						<img
							src="../../assets/projects-icons/empty-list-projects.svg"
							alt=""
						/>
					</section>
					<section
						v-else-if="
							!loadingProjects &&
								allProjectsList.length == 0 &&
								searchTopicTest != ''
						"
						class="h-100 d-flex align-items-center justify-content-center w-100"
					>
						<div class="text-center">
							<img
								src="../../assets/projects-icons/no-search-projects.svg"
								alt=""
							/>
							<div class="no-data-txt">
								No matching result for "{{ searchTopicTest }}"
							</div>
						</div>
					</section>
					<section class="d-flex flex-wrap gap-3px">
						<section
							v-for="(project, index) in allProjectsList"
							:key="project.testID"
							class="common-sm-card"
						>
							<b-card
								:class="
									selectedProjectIndex == index ||
									selectedTestID == project.testID
										? 'selected-card'
										: ''
								"
							>
								<b-row class="w-100 d-flex align-items-center m-0">
									<b-col class="d-flex align-items-center p-0" cols="7">
										<img
											src="../../assets/projects-icons/code-icon.svg"
											alt=""
											class="mr-2"
										/>
										<span class="proj-head w-100 text-truncate">
											{{ project.name }}
										</span>
									</b-col>
									<b-col
										v-if="project.active"
										class="d-flex align-items-center w-50 justify-content-end p-0"
									>
										<img
											v-if="selectedProjectIndex === index"
											@click="
												(selectedProject = null), (selectedProjectIndex = null)
											"
											src="../../assets/projects-icons/view-open.svg"
											alt=""
											class="mr-2 pointer newIcons-hover"
										/>
										<img
											@click="selectProject(project, index)"
											v-else
											alt=""
											src="../../assets/projects-icons/view-icon.svg"
											class="mr-2 pointer newIcons-hover"
										/>
										<img
											@click="goToSharePage(project)"
											src="../../assets/projects-icons/share-icon.svg"
											alt=""
											class="mr-2 pointer newIcons-hover"
										/>
										<section class="dropdown-class">
											<b-dropdown
												boundary="window"
												right
												class="m-0"
												no-caret
												@shown="isDropdownVisible = true"
												@hidden="isDropdownVisible = false"
											>
												<template #button-content>
													<img
														src="../../assets/projects-icons/inform-icon.svg"
														alt=""
														class="pointer newIcons-hover"
													/>
												</template>

												<b-dropdown-group v-if="leaderboardAdminAccess">
													<b-dropdown-item
														@click="openConfirmModal(index, 'PublicAvail')"
													>
														<img
															v-if="project.publicAvailability"
															src="../../assets/projects-icons/public-icon.svg"
															alt=""
															class="mr-3"
														/>
														<img
															v-else
															src="../../assets/Testlockred.svg"
															alt=""
															class="mr-2"
														/>
														{{
															project.publicAvailability
																? "Make Project Private"
																: "Make Project Public"
														}}
													</b-dropdown-item>
												</b-dropdown-group>
												<b-dropdown-group>
													<b-dropdown-item
														@click="openConfirmModal(index, 'Lock')"
													>
														<img
															v-if="!project.isLocked"
															src="../../assets/projects-icons/lock-icon.svg"
															alt=""
															class="mr-3"
														/>
														<img
															v-else
															src="../../assets/lockiconactive.svg"
															alt=""
															class="mr-3"
														/>
														{{
															project.isLocked
																? "Unlock Project"
																: "Lock Project"
														}}
													</b-dropdown-item>
												</b-dropdown-group>

												<b-dropdown-group>
													<b-dropdown-item @click="showTaggedInfo(project)">
														<img
															src="../../assets/projects-icons/config-icon.svg"
															alt=""
															class="mr-3"
														/>
														Configuration</b-dropdown-item
													>
												</b-dropdown-group>
												<b-dropdown-group>
													<b-dropdown-item @click="cloneModal = project">
														<img
															src="../../assets/projects-icons/clone-icon.svg"
															alt=""
															class="mr-3"
														/>
														Clone Project</b-dropdown-item
													>
												</b-dropdown-group>
												<b-dropdown-group v-if="!project.isLocked">
													<b-dropdown-item
														@click="
															$router.push({
																name: 'editprojects',
																params: { id: project.testID },
															})
														"
													>
														<img
															src="../../assets/projects-icons/edit-icon.svg"
															alt=""
															class="mr-3"
														/>
														Edit Project</b-dropdown-item
													>
												</b-dropdown-group>
												<b-dropdown-group v-if="!project.isLocked">
													<b-dropdown-item
														@click="openConfirmModal(index, 'Delete')"
													>
														<img
															src="../../assets/projects-icons/delete-icon.svg"
															alt=""
															class="mr-3"
														/>
														Delete Project
													</b-dropdown-item>
												</b-dropdown-group>
											</b-dropdown>
										</section>
									</b-col>
									<b-col
										v-else
										class="d-flex align-items-center w-50 justify-content-end p-0"
									>
										<img
											@click="cloneModal = project"
											src="../../assets/projects-icons/clone-inactive.svg"
											alt=""
											class="mr-2 pointer"
										/>
										<img
											@click="openConfirmModal(index, 'Activate')"
											src="../../assets/activate.svg"
											alt=""
											class="mr-2 pointer"
										/>
										<img
											v-if="selectedProjectIndex === index"
											@click="
												(selectedProject = null), (selectedProjectIndex = null)
											"
											src="../../assets/projects-icons/view-open.svg"
											alt=""
											class="mr-2 pointer newIcons-hover"
										/>
										<img
											@click="selectProject(project, index)"
											v-else
											alt=""
											src="../../assets/projects-icons/view-icon.svg"
											class="mr-2 pointer newIcons-hover"
										/>
									</b-col>
								</b-row>
								<section class="mt-2 relativeclass activity-class w-100">
									<section class="inactive-class w-100" v-if="!project.active">
										Inactive
									</section>
									<section
										class="d-flex align-items-center justify-content-center w-100"
										style="gap: 20px"
									>
										<section class="text-center mt-25px">
											<div class="activity-grey-number">
												{{ project.assigned }}
											</div>
											<div class="activity-font mt-2">Assigned</div>
										</section>
										<section class="text-center mt-25px">
											<div class="activity-green-number">
												{{ project.submitted }}
											</div>
											<div class="activity-font mt-2">Submitted</div>
										</section>
										<section class="text-center mt-25px">
											<div class="activity-orange-number">
												{{ project.running }}
											</div>
											<div class="activity-font mt-2">Running</div>
										</section>
									</section>
								</section>
							</b-card>
						</section>
					</section>

					<template v-if="loadingProjects">
						<section class="d-flex flex-wrap gap-3px">
							<section v-for="i in 10" :key="i" class="card-ske">
								<b-skeleton height="100%" width="100%" />
							</section>
						</section>
					</template>
				</section>
			</b-container>
			<b-container
				v-if="loadingProjects || (allProjects && allProjects.totalProjects > 0)"
				class="right-container ml-2"
			>
				<section
					v-if="!selectedProject && !showTagged"
					class="h-100 d-flex align-items-center justify-content-center w-100"
				>
					<img
						src="../../assets/projects-icons/empty-right-projects.svg"
						alt=""
					/>
				</section>
				<section v-else-if="!showTagged">
					<section class="w-100 px-3 py-2">
						<h2>Sandbox Details</h2>
					</section>
					<hr class="mb-0" />
					<section
						class="px-3 overflow-auto pt-3"
						style="height: calc(100vh - 267px)"
					>
						<section class="mb-3">
							<section>
								<section class="right-container-head">Project Title</section>
								<section class="right-container-subhead">
									{{ selectedProject.name }}
								</section>
							</section>
							<section class="mt-3">
								<section class="right-container-head">Project Template</section>
								<section class="right-container-subhead">
									{{ selectedProject.templateTitle }}
								</section>
							</section>
							<section class="mt-3">
								<section class="right-container-head">Tags</section>
								<section class="right-container-subhead">
									<section
										class="d-flex align-items-center flex-wrap gap-15px mt-2"
									>
										<section
											class="right-container-tags wordbreak"
											v-for="(tags, index) in selectedProject.tags"
											:key="index"
										>
											{{ tags }}
										</section>
									</section>
								</section>
							</section>
							<section class="mt-3">
								<section class="right-container-head">
									Project Description
								</section>
								<section
									class="right-container-subhead"
									v-html="selectedProject.description"
								></section>
							</section>
							<section class="mt-3">
								<section class="right-container-head">Category</section>
								<section class="right-container-subhead">
									{{ selectedProject.categoryTitle }}
								</section>
							</section>
							<section class="mt-3">
								<section class="right-container-head">Sub-category</section>
								<section class="right-container-subhead">
									{{ selectedProject.subCategoryTitle }}
								</section>
							</section>
							<section class="mt-3" v-if="selectedProject.setPricing">
								<section class="right-container-head">Price</section>
								<section class="right-container-subhead">
									<span
										v-if="
											Number(selectedProject.listPrice) ===
												Number(selectedProject.finalPrice)
										"
										class="right-container-subhead"
									>
										₹{{ selectedProject.finalPrice }}
									</span>
									<template v-else>
										<span
											style="font-family: 'Montserrat',sans-serif;font-weight: 400;font-size: 13px;text-decoration-line: line-through;color: #999999;"
										>
											Rs.{{ selectedProject.listPrice }}
										</span>

										<span class="right-container-subhead">
											₹{{ selectedProject.finalPrice }}
										</span>
									</template>
								</section>
							</section>
							<section class="mt-3" v-if="!selectedProject.setPricing">
								<section class="right-container-head">Price</section>
								<section class="right-container-subhead">
									Free
								</section>
							</section>
							<section class="mt-3">
								<section class="right-container-head">Marks</section>
								<section class="right-container-subhead">
									{{ selectedProject.marks }}
								</section>
							</section>
							<section class="mt-3">
								<section class="right-container-head">Difficulty Level</section>
								<section class="right-container-subhead">
									{{ selectedProject.averageDifficulty }}
								</section>
							</section>
							<section class="mt-3">
								<section class="right-container-head">
									Project Check Metrices
								</section>
								<section
									v-for="(metric, index) in selectedProject.checkingMetrics"
									:key="index"
									class="right-container-subhead d-flex align-items-center gap-15px mt-1"
								>
									<img
										v-if="metric.opted"
										src="../../assets/projects-icons/right-tick.svg"
										alt=""
									/>
									<img
										v-else
										src="../../assets/projects-icons/wrong-tick.svg"
										alt=""
									/>
									{{ metric.name }}
								</section>
							</section>
						</section>
					</section>
				</section>
				<sideConfig
					v-if="showTagged && !selectedProjectIndex"
					:testID="selectedTestID"
					:topicID="selectedTopicID"
				/>
				<div
					v-if="selectedProject && !selectedProject.active && !showTagged"
					class="activate-blue d-flex justify-content-end align-items-center"
				>
					<b-button
						@click="openConfirmModal(selectedProjectIndex, 'Activate')"
						class="cursor-pointer"
					>
						<img
							class="mr-2"
							src="../../assets/projects-icons/white-activate.svg"
							alt=""
						/>
						Activate
					</b-button>
				</div>
			</b-container>
		</body>
		<ConfirmationModal
			v-if="isConfirmModal"
			:header="headTxt"
			:button="btnTxt"
			:showModal="isConfirmModal"
			:confirmMessage="confirmMessage"
			:svgPath="svgPath"
			@save="confirmType == 'Delete' ? deleteProjects() : editProjects()"
			@close="close"
		/>
		<CloneModal
			v-if="cloneModal"
			@close="cloneModal = null"
			:modalValue="cloneModal"
			@clone="cloneProjects"
		/>
		<PublicAvailability
			v-if="showPublicAvailModal && publicAvailProject"
			mode="project"
			:showModal="showPublicAvailModal"
			:projectDetails="publicAvailProject"
			@hide="showPublicAvailModal = false"
			@updated="onPublicAvailUpdated"
		/>
	</main>
</template>

<script>
import SingleSelect from "../../components/InputComponents/SingleSelect.vue";
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import CloneModal from "../../components/modals/CloneModal";
import errorToast from "../../views/mixin/toast";
import successToast from "../../views/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import sideConfig from "../../views/sandboxes/sideConfigSandbox.vue";
import PublicAvailability from "../../controllers/Test/modals/PublicAvailability.vue";
import {
	getAllProjects,
	getSandBoxTemplate,
	getProject,
	getCategories,
	getSubCategories,
	deleteProject,
	cloneProject,
	editProject,
} from "../../utils/apiFunctions";
import { mapGetters } from "vuex";

export default {
	name: "MyProjects",
	mixins: [errorToast, successToast],
	data() {
		return {
			showTagged: false,
			selectedTestID: null,
			selectedTopicID: null,
			filterApllied: false,
			LoaderStatus: false,
			cloneModal: null,
			loadingProjects: false,
			confirmMessage: "",
			btnTxt: "",
			headTxt: "",
			confirmType: "",
			projectIndex: null,
			svgPath: "",
			isConfirmModal: false,
			showPublicAvailModal: false,
			publicAvailProject: null,
			allProjects: null,
			allProjectsList: [],
			selectedProject: null,
			selectedProjectIndex: null,
			sandboxTemplates: [],
			filters: {
				projectStatus: null,
				category: null,
				template: null,
				name: null,
				count: 20,
				page: 0,
			},

			status: [
				{ text: "All", value: "all" },
				{ text: "Active", value: "active" },
				{ text: "Inactive", value: "inactive" },
			],
			openFilter: false,
			isDropdownVisible: false,
			metrics: [
				{ label: "Sonar Cube", value: 1 },
				{ label: "DB Triggers", value: 2 },
				{ label: "Build the Project (Check for errors)", value: 3 },
				{ label: "Time & Space Complexity", value: 4 },
			],
		};
	},
	components: {
		SingleSelect,
		ConfirmationModal,
		CloneModal,
		Spinner,
		sideConfig,
		PublicAvailability,
	},
	computed: {
		...mapGetters("testVUEX", {
			categories: "getCategories",
		}),
		...mapGetters("searchVUEX", {
			searchTopicTest: "getSearchTopicTest",
		}),
		...mapGetters("sandboxVUEX", {
			appliedFilter: "getAppliedFilters",
		}),
		...mapGetters("userVUEX", {
			leaderboardAdminAccess: "getleaderboardAdminAccess",
		}),

		disabeFilters() {
			return (
				!this.filters.projectStatus?.value &&
				!this.filters.category?.value &&
				!this.filters.template?.value
			);
		},
	},
	async mounted() {
		this.$store.commit("sandboxVUEX/resetSandboxDetails");
		this.$store.commit("sandboxVUEX/resetCheckingMetrics");
		try {
			this.getCategories();
			this.getSubCategories();
			this.getAllProjectsMethod();
			const templates = await getSandBoxTemplate();
			this.sandboxTemplates = this.getDropdownValues(templates.data.data.data);
		} catch (error) {
			return error;
		}
	},
	watch: {
		searchTopicTest() {
			this.filters.name = this.searchTopicTest;
			this.allProjectsList = [];
			this.filters.page = 0;
			this.getAllProjectsMethod();
		},
	},
	methods: {
		showTaggedInfo(data) {
			this.showTagged = true;
			this.selectedProjectIndex = null;
			this.selectedTestID = data.testID;
			this.selectedTopicID = data.topicID;
		},
		openConfirmModal(index, type) {
			let obj = this.allProjectsList[index];
			this.projectIndex = index;
			this.confirmType = type;
			if (type == "Activate") {
				this.confirmMessage = `Are you sure you want to activate <span class="supporting-txt">"${obj.name}"</span>?`;
				this.btnTxt = "Activate";
				this.svgPath = "projects-icons/activateWarn.svg";
				this.headTxt = "Activate Project";
			} else if (type == "Delete") {
				this.confirmMessage = `Are you sure you want to delete <span class="supporting-txt">"${obj.name}"</span>? This action cannot be undone.`;
				this.btnTxt = "Delete";
				this.svgPath = "projects-icons/deleteProject.svg";
				this.headTxt = "Delete Project";
			} else if (type == "Lock") {
				this.btnTxt = `${obj.isLocked ? "Unlock" : "Lock"}`;
				this.confirmMessage = `Are you sure you want to ${
					obj.isLocked ? "Unlock" : "Lock"
				}
         <span class="supporting-txt">"${obj.name}"</span>?`;
				this.headTxt = obj.isLocked ? "Unlock Project" : "Lock Project";
				this.svgPath = obj.isLocked
					? "projects-icons/unlockProject.svg"
					: "projects-icons/lockProject.svg";
			} else {
				// Open the full PublicAvailability modal instead of a simple confirm
				this.publicAvailProject = obj;
				this.showPublicAvailModal = true;
				return;
			}
			this.isConfirmModal = true;
		},
		close() {
			this.isConfirmModal = false;
		},
		goToSharePage(project) {
			this.$router.push({
				name: "sharesandbox",
				params: {
					testID: project.testID,
					topicID: project.topicID,
				},
				query: {
					type: 4,
					testqp: "outside",
					groupType: "I",
				},
			});
		},
		onScroll(e) {
			const { target } = e;

			if (
				Math.ceil(target.scrollTop) >=
				target.scrollHeight - target.offsetHeight
			) {
				if (
					this.checkbetween(this.allProjects.pageEnd, 0, this.allProjects.total)
				) {
					this.filters.page++;
					this.getAllProjectsMethod();
				}
			}
		},
		checkbetween(x, min, max) {
			return x > min && x < max;
		},
		async cloneProjects(project) {
			this.LoaderStatus = true;
			try {
				const response = await cloneProject(project.testID, {
					name: project.name,
				});
				if (response.status == 200) {
					this.allProjectsList = [];
					this.filters.page = 0;
					this.getAllProjectsMethod();
					this.successToast("Project cloned successfully.");
					this.cloneModal = null;
				} else {
					this.errorToast(response.data.data.Detail);
				}
			} catch (error) {
				this.errorToast("Unable cloned project.");
				this.cloneModal = null;
			} finally {
				this.LoaderStatus = false;
			}
		},
		async deleteProjects() {
			this.LoaderStatus = true;
			try {
				const response = await deleteProject(
					this.allProjectsList[this.projectIndex].testID
				);
				if (response.status === 200) {
					this.allProjectsList = [];
					this.filters.page = 0;
					this.successToast("Project deleted successfully.");
					this.allProjectsList = [];
					this.getAllProjectsMethod();
				} else {
					throw new Error();
				}
			} catch (error) {
				this.errorToast("Unable delete project.");
			} finally {
				this.isConfirmModal = false;
				this.LoaderStatus = false;
			}
		},
		async editProjects() {
			this.LoaderStatus = true;
			var successMsg = "Project saved successfully!";
			try {
				let payload;
				if (this.confirmType == "Activate") {
					payload = { active: true };
					successMsg = "Project activated succesfully!";
			} else if (this.confirmType == "Lock") {
					payload = {
						isLocked: !this.allProjectsList[this.projectIndex].isLocked,
					};
					if (!this.allProjectsList[this.projectIndex].isLocked) {
						successMsg = "Project locked succesfully!";
					} else {
						successMsg = "Project unlocked succesfully!";
					}
				}
				const response = await editProject(
					this.allProjectsList[this.projectIndex].testID,
					payload
				);
				if (response.status == 200) {
					this.allProjectsList = [];
					this.filters.page = 0;
					this.successToast(successMsg);
					this.allProjectsList = [];
					this.getAllProjectsMethod();
					this.LoaderStatus = false;
				} else {
					throw new Error();
				}
			} catch (error) {
				this.errorToast("Something went wrong please try again later.");
			} finally {
				this.isConfirmModal = false;
			}
		},
		async getCategories() {
			try {
				const res = await getCategories();
				if (res.status == 200) {
					this.$store.commit("testVUEX/saveCategories", res.data.data);
				} else {
					throw new Error("Failed to fetch categories");
				}
			} catch (error) {
				console.error(error);
				this.categories = [];
			}
		},
		async getSubCategories() {
			try {
				const res = await getSubCategories();
				if (res.status == 200) {
					this.$store.commit("testVUEX/saveSubCategories", res.data.data);
				} else {
					throw new Error("Failed to fetch sub categories");
				}
			} catch (error) {
				console.error(error);
				this.subCategories = [];
			}
		},
		onPublicAvailUpdated() {
			this.showPublicAvailModal = false;
			this.publicAvailProject = null;
			this.allProjectsList = [];
			this.filters.page = 0;
			this.getAllProjectsMethod();
		},
		hideFiltersDropdown() {
			this.openFilter = false;
			this.filters.projectStatus = this.appliedFilter.projectStatus;
			this.filters.category = this.appliedFilter.category;
			this.filters.template = this.appliedFilter.template;
		},
		applyFilters() {
			this.filters.page = 0;
			this.allProjectsList = [];
			this.filterApllied = true;
			this.$store.commit("sandboxVUEX/setAppliedFilters", this.filters);
			this.openFilter = false;
			this.getAllProjectsMethod();
		},
		resetFilters() {
			this.filters.projectStatus = null;
			this.filters.category = null;
			this.filters.template = null;
			this.$store.commit("sandboxVUEX/setAppliedFilters", this.filters);
			this.openFilter = false;
			if (this.filterApllied) {
				this.filters.page = 0;
				this.allProjectsList = [];
				this.getAllProjectsMethod();
				this.filterApllied = false;
			}
		},
		async selectProject(project, index) {
			try {
				this.selectedProjectIndex = index;
				this.selectedTestID = null;
				this.selectedTopicID = null;
				this.showTagged = false;
				const response = await getProject(project.testID, true);
				this.selectedProject = response.data.data;
			} catch (error) {
				console.log(error);
			}
		},
		async getAllProjectsMethod() {
			try {
				this.selectedProject = null;
				this.selectedProjectIndex = null;
				this.loadingProjects = true;
				let filterPayload = {
					...this.filters,
				};
				if (this.filters.projectStatus)
					filterPayload["status"] = this.filters.projectStatus.value;
				if (this.filters.category)
					filterPayload["categoryID"] = this.filters.category.value;
				if (this.filters.template)
					filterPayload["templateID"] = this.filters.template.value;
				delete filterPayload.projectStatus;
				delete filterPayload.category;
				delete filterPayload.template;
				const response = await getAllProjects(filterPayload);
				this.allProjects = response.data.data;
				this.allProjectsList = [
					...this.allProjectsList,
					...response.data.data.data,
				];
			} catch (error) {
				console.log(error);
			} finally {
				this.loadingProjects = false;
			}
		},
		getDropdownValues(values) {
			return values.map((value) => ({
				text: value.title,
				value: value.questionKey,
				...value,
			}));
		},
	},
};
</script>

<style scoped>
.gap-3px {
	gap: 2rem;
}
.card-ske {
	height: 154px;
	width: 271px;
}
.left-container h2 {
	font-family: var(--lato);
	font-weight: var(--weight-LM);
	font-size: var(--size-16);
	color: var(--color-black);
	margin: 0;
}

.projects-overflow {
	min-height: auto;
	max-height: calc(100vh - 245px);
	overflow-y: auto;
	overflow-x: hidden;
}

.proj-head {
	font-family: var(--lato);
	font-weight: var(--weight-LM);
	font-size: 15px;
	color: #000000;
}

.activity-class {
	background: rgba(114, 115, 142, 0.1);
	border-radius: 8px;
	height: 85px;
}

.activity-grey-number {
	font-family: var(--lato);
	font-weight: var(--weight-M);
	font-size: var(--size-14);
	color: var(--light-grey);
}

.activity-green-number {
	font-family: var(--lato);
	font-weight: var(--weight-M);
	font-size: var(--size-14);
	color: #038e00;
}

.activity-orange-number {
	font-family: var(--lato);
	font-weight: var(--weight-M);
	font-size: var(--size-14);
	color: #ffc145;
}

.activity-font {
	font-family: var(--lato);
	font-weight: var(--weight-R);
	font-size: var(--size-14);
	color: var(--light-grey);
}

.inactive-class {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 4px;
	gap: var(--size-10);
	background: #f4d5d5;
	border-radius: 4px 4px 0px 0px;
	font-family: var(--Montserrat);
	font-weight: var(--weight-M);
	font-size: 9px;
	color: #ee164f;
	position: absolute;
	top: 0;
}

.mt-25px {
	margin-top: 25px;
}

.right-container h2 {
	font-family: var(--Montserrat);
	font-weight: var(--weight-M);
	font-size: var(--size-16);
	color: #344054;
	margin: 0;
}

.right-container-head {
	font-family: var(--Montserrat);
	font-weight: var(--weight-LM);
	font-size: 13px;
	color: #3a3c40;
}

.right-container-subhead {
	font-family: var(--Montserrat);
	font-weight: var(--weight-M);
	font-size: var(--size-14);
	color: #3a3c40;
}

.right-container-tags {
	background: rgba(114, 115, 142, 0.1);
	border-radius: 14.7861px;
	font-family: var(--Montserrat);
	font-weight: var(--weight-R);
	font-size: 12px;
	color: var(--navy-blue);
	padding: 4px 12px;
}

.selected-card {
	border: 2px solid rgba(114, 115, 142, 1);
}

.gap-15px {
	gap: 15px;
}
.activate-blue {
	border-top: 1px solid #d7d7d7;
	padding: 10px;
}
.activate-blue .btn-secondary {
	padding: 4px 16px;
	background: #20639b;
	border-radius: 40px;
	width: 135px;
	height: 32px;
	font-family: "Montserrat";
	font-weight: 600;
	font-size: 13px;
	color: #ffffff;
}
.no-data-txt {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	color: #344054;
}

.common-main-container {
	height: calc(100vh - 72px);
	top: 72px;
	padding-left: 80px;
	padding-right: 15px;
	width: auto;
}
</style>
